import BaseService from "./BaseService";
import { DepartmentRequest, DepartmentResponse, DepartmentsResponse } from "./mappers/DepartmentMapper";
import store from "@/store";

class DepartmentService extends BaseService {
  constructor() {
    super();
  }
  addDepartment(name, company, parent, info) {
    let addDepartment = {
      name: name,
      company: company,
      parent: parent,
      info: info
    };
    store.dispatch("app/setDepartments", null);
    return new Promise((resolve, reject) => {
      return this.post("departments/", addDepartment)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  createDepartment(data) {
    return this.post(`departments/`, DepartmentRequest(data))
      .then((response) => response.data)
      .then((data) => DepartmentResponse(data));
  }

  createCompanyDepartment(id, data) {
    store.dispatch("app/setDepartments", null);
    return this.post(`companies/${id}/departments/`, DepartmentRequest(data))
      .then((response) => response.data)
      .then((data) => DepartmentResponse(data));
  }

  getDepartment(id) {
    return this.get(`departments/${id}/`)
      .then((response) => response.data)
      .then((data) => DepartmentResponse(data));
  }

  getDepartments() {
    return this.get(`departments/`)
      .then((response) => response.data)
      .then((data) => DepartmentsResponse(data));
  }

  getDepartmentsByCompany(id, tree = false, forceRefetch = false) {
    var url;
    let modifiedData;

    if (forceRefetch == true) {
      store.dispatch("app/setDepartments", null);
    }

    if (!tree && (store.getters["app/departments"] != null)) {
      return Promise.resolve(store.getters["app/departments"]);
    }

    if (tree) {
      url = `companies/${id}/departments/tree/`;
    } else {
      url = `companies/${id}/departments/`;
    }

    return this.get(url)
      .then((response) => response.data)
      .then((data) => {
        modifiedData = DepartmentsResponse(data);
        if (!tree) {
          store.dispatch("app/setDepartments", modifiedData);
        }
        return modifiedData;
      })
      .then(() => modifiedData);
  }

  updateDepartment(id, data) {
    store.dispatch("app/setDepartments", null);
    return this.patch(`departments/${id}/`, DepartmentRequest(data))
      .then((response) => response.data)
      .then((data) => DepartmentResponse(data));
  }

  deleteDepartment(id, isDeleteChildren = false) {
    store.dispatch("app/setDepartments", null);
    let deleteChildren = isDeleteChildren ? `?delete-children=1` : "";
    return this.delete(`departments/${id}/${deleteChildren}`);
  }
}

export default new DepartmentService();
